<template>
  <div class="ma-4">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-skeleton-loader class="mx-auto" type="table" />
    </v-sheet>

    <div v-show="!showSkeleton" class="text-h4 mb-2">Grupos de Expressões</div>
    <v-data-iterator
      v-show="!showSkeleton"
      :no-data-text="noDataText"
      :items="dataRegex"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :no-results-text="noResultsText"
      hide-default-footer
    >
      <template v-slot:header>
        <v-row>
          <v-col cols="7" class="my-2">
            <v-btn
              dark
              color="orangePcm"
              href="/pabx/cadastro/aliasregex/criar"
              target="_blank"
              @click="handleGoToNewAliasRegex"
            >
              Criar Grupo de Expressões
            </v-btn>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="search" clearable hide-details prepend-inner-icon="mdi-magnify" label="Busca" />
          </v-col>
        </v-row>
      </template>
      <template v-slot:default="props">
        <v-data-table
          dense
          :headers="headers"
          :items="props.items"
          hide-default-footer
          class="elevation-1"
          disable-pagination
          @dblclick:row="atualizar"
        >
          <template v-slot:[`item.botoes`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  dark
                  color="bluePcm"
                  class="ma-2"
                  :href="`/pabx/cadastro/aliasregex/atualizar/${item._id}`"
                  target="_blank"
                  v-bind="attrs"
                  v-on="on"
                  @click="atualizarButton(item, $event)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="deletar(item)" icon small dark color="darkRed" v-bind="attrs" v-on="on">
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>Remover</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <div class="ml-4 mb-2 grey--text">
            <p>Total de Grupos de Expressões: {{ qtdRegex }}</p>
          </div>
          <v-spacer />
          <div class="pb-5">
            <ListPagination
              :page="page"
              :numberOfPages="numberOfPages"
              @firstPage="firstPage"
              @formerPage="formerPage"
              @nextPage="nextPage"
              @lastPage="lastPage"
            />
          </div>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import ListPagination from '@/componentes/ListPagination'
import { registerVuexModule } from '@/utils/vuexUtils'
import { pagesHomeMixins } from '@/mixins/pagesHomeMixins'

import regexsStore from '../_store'
import regexHttpService from '../_services/regexHttpService'

export default {
  components: { ListPagination },

  mixins: [pagesHomeMixins],

  data: () => ({
    headers: [
      {
        text: 'Descrição',
        value: 'description',
        align: 'left',
      },
      {
        text: 'Ações',
        value: 'botoes',
        align: 'center',
        sortable: false,
      },
    ],
    dataRegex: [],
  }),

  computed: {
    ...mapGetters('alliasRegexHomeModulePABXStore', ['getRegexs']),

    numberOfPages() {
      return Math.ceil(this.dataRegex.length / this.itemsPerPage)
    },
    qtdRegex() {
      return this.dataRegex.length
    },
  },

  async created() {
    registerVuexModule(this.$store, 'alliasRegexHomeModulePABXStore', regexsStore)

    await this.listarTodasRegex()
    this.dataRegex = [...this.getRegexs]
    if(this.dataRegex.length > 0){
      this.dataRegex = this.dataRegex.filter(( regex ) => regex.description !== 'TODOS RAMAIS' && regex.description !== 'TODOS OPERADORES');
    }
    this.showSkeleton = false
  },

  methods: {
    ...mapActions('alliasRegexHomeModulePABXStore', ['listarTodasRegex']),

    handleGoToNewAliasRegex(event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const goToNewAliasRegex = this.$router.resolve({ name: 'Aliasregex/criar' })
        window.open(goToNewAliasRegex.href, '_blank')
      } else {
        this.$router.push({ name: 'Aliasregex/criar' })
      }
    },

    atualizar(event, item) {
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`aliasregex/atualizar/${item.item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`aliasregex/atualizar/${item.item._id}`)
      }
    },

    atualizarButton(item, event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`aliasregex/atualizar/${item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`aliasregex/atualizar/${item._id}`)
      }
    },

    async deletar(item) {
      let resultado = window.confirm(`Deseja remover o grupo de expressões "${item.description}"?`)
      if (resultado) {
        try {
          await regexHttpService.deleteRegex(item._id)
          this.dataRegex = this.dataRegex.filter(x => x._id !== item._id)
        } catch (error) {
          alert(error.response.data)
        }
      }
    },
  },
}
</script>
